import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { json, NavLink, useNavigate } from 'react-router-dom';

import Movies, { Tvlst, Peplelist } from '../Interface/Interface';
import profile from '../images/pngwing.com.png'
export default function Home() {

  const [moviesList, setMoviesList] = useState([]);
  const [tvList, setTvList] = useState([]);
  const [peopleList, setPeopleList] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    getTrending('movie', setMoviesList);
    getTrending('tv', setTvList);
    getTrending('person', setPeopleList);
    setLoading(true)



  }, [])
  function getDetails(id: number, type: string) {
    sessionStorage.setItem('movieID', JSON.stringify(id));
    sessionStorage.setItem('movieType', type);

    navigate('/details')
  }

  async function getTrending(type: string, callBack: any) {

    const { data } = await axios.get(`https://api.themoviedb.org/3/trending/${type}/day?api_key=52554469fe208e948caaf074d2683e95`);
    const trending = data.results.slice(0, 18);
    callBack(trending)
    setLoading(false)

  }
  return (<>
    {loading ? <div className='loaddrComtainer '>
      <span className="loader"></span>
    </div> : <>
      <div className="row py-3 text-center">
        <div className="col-md-4 d-flex align-items-center  ">
          <div>
            <h2 className='py-2'>   Trending <NavLink to={'/movies'} className='main-type p-1 '>Movies</NavLink> to watch</h2>

            <p className='text-muted'> must watch tv shows by day</p>
          </div>
        </div>
        {moviesList.map((el: Movies, index) => index < 10 ? <div className='col-md-2 movie-item py-3' key={index} onClick={() => getDetails(el.id, 'movie')} >

          <img src={`https://image.tmdb.org/t/p/w500/` + el.poster_path} className='img-fluid pb-1 ' alt={el.title} />




          <h5 className='votes p-1'>{el.vote_average.toString().slice(0, 3)}</h5>
          {el.title.length < 15 ? <h5 >{el.title}</h5 > : <h5 >{el.title.slice(0, 15)}...</h5 >}

        </div> : ''
        )}

      </div>

      <div className="row py-3 text-center">
        <div className="col-md-4 d-flex align-items-center  ">
          <div>
            <h2 className='py-2'>   Trending <NavLink to={'/tv'} className='main-type p-1 '>TvShows</NavLink> to watch</h2>

            <p className='text-muted'> must watch tv shows by day</p>
          </div>
        </div>

        {tvList.map((el: Tvlst, index) => index < 10 ? <div className='col-md-2 movie-item py-3' key={index} onClick={() => getDetails(el.id, 'tv')}>
          <img src={`https://image.tmdb.org/t/p/w500/` + el.poster_path} className='img-fluid pb-1' alt={el.name} />
          <h5 className='votes p-1'>{el.vote_average.toString().slice(0, 3)}</h5>
          {el.name.length < 15 ? <h5 >{el.name}</h5 > : <h5 >{el.name.slice(0, 15)}...</h5 >}

        </div> : ''
        )}

      </div>

      <div className="row py-3 text-center">
        <div className="col-md-4 d-flex align-items-center  ">
          <div>
            <h2 className='py-2'>   Trending <NavLink to={'/people'} className='main-type p-1 '>People</NavLink> to watch</h2>

            <p className='text-muted'> must watch tv shows by day</p>
          </div>
        </div> 
        
        {peopleList.map((el: Peplelist, index) => index < 11 ? index!=4? <div className='col-md-2 movie-item py-3' key={index} onClick={() => getDetails(el.id, 'person')}>
          {el.profile_path ? <img src={`https://image.tmdb.org/t/p/w500/` + el.profile_path} className='img-fluid' alt={el.name} /> : <img src={profile} className='img-fluid' alt={el.name} />}


          {el.name.length < 15 ? <h5 >{el.name}</h5 > : <h5 >{el.name.slice(0, 15)}...</h5 >}
        </div> : '' :''
        )}

      </div>
    </>

    }



  </>

  )
}
